import { LocalStorageKey } from "common/helpers/userData";
import { UserRole } from "components/Reports/reportAssets/assets";
import { tUserRole } from "i18n/enums";

export const getInitialRole = (role: string) => {
  switch (role) {
    case "Regular":
      return { value: UserRole.REGULAR, label: tUserRole(UserRole.REGULAR) };
    case "Senior":
      return { value: UserRole.SENIOR, label: tUserRole(UserRole.SENIOR) };
    case "ControlCenter":
      return {
        value: UserRole.CONTROLCENTER,
        label: tUserRole(UserRole.CONTROLCENTER),
      };
    case "SeniorWatch":
      return {
        value: UserRole.SENIOR_WATCH,
        label: tUserRole(UserRole.SENIOR_WATCH),
      };

    default:
      return null;
  }
};

export const convertRolesToSelecteArray = (roles: string[]) => {
  const rolesArray = [];
  roles?.forEach((role) => {
    if (role === "Regular") {
      rolesArray.push({
        value: UserRole.REGULAR,
        label: tUserRole(UserRole.REGULAR),
      });
    } else if (role === "Senior") {
      rolesArray.push({
        value: UserRole.SENIOR,
        label: tUserRole(UserRole.SENIOR),
      });
    } else if (role === "ControlCenter") {
      rolesArray.push({
        value: UserRole.CONTROLCENTER,
        label: tUserRole(UserRole.CONTROLCENTER),
      });
    } else if (role === "SeniorWatch") {
      rolesArray.push({
        value: UserRole.SENIOR_WATCH,
        label: tUserRole(UserRole.SENIOR_WATCH),
      });
    }
  });
  return rolesArray.sort(
    (
      a: { value: number; label: string },
      b: { value: number; label: string }
    ) => a.value - b.value
  );
};
export const completeLocalStorageData = (setselectedRole, userData) => {
  const keys = Object.values(LocalStorageKey);
  keys.forEach((key) => {
    if (localStorage.getItem(key) === null) {
      switch (key) {
        case "roles":
          localStorage.setItem(
            key,
            JSON.stringify(convertRolesToSelecteArray(userData.userRoles))
          );
          break;
        case "userId":
          localStorage.setItem(key, userData.id);
          break;
        case "name":
          localStorage.setItem(key, userData.userName);
          break;
        case "selectedRole": {
          const roles = userData.userRoles;
          const initialRole = getInitialRole(
            Array.isArray(roles) ? roles[0] : roles
          );
          initialRole && setselectedRole(initialRole);
          break;
        }
        default:
          break;
      }
    }
  });
};
